const Index = () => import("./index");
const PaymentsReport = () => import("./PaymentReports.vue");

export default [{
  path: "payment",
  name: "payment-report",
  component: Index,
  redirect: {
    name: "payment-summary",
  },
  children: [{
    path: "date",
    name: "payment-summary",
    component: PaymentsReport,
  }],
},
]
